import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["defaultInputValue", "defaultOpen", "defaultSelected", "labelKey", "multiple"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import { useEffect, useReducer, useRef } from 'react';
import { getOptionLabel, isFunction } from '../utils';
export function getInitialState(_ref) {
  var defaultInputValue = _ref.defaultInputValue,
    defaultOpen = _ref.defaultOpen,
    defaultSelected = _ref.defaultSelected,
    labelKey = _ref.labelKey,
    multiple = _ref.multiple,
    props = _objectWithoutProperties(_ref, _excluded);
  var selected = props.selected ? props.selected.slice() : defaultSelected.slice();
  var text = defaultInputValue;
  if (!multiple && selected.length) {
    // Set the text if an initial selection is passed in.
    text = getOptionLabel(selected[0], labelKey);
    if (selected.length > 1) {
      // Limit to 1 selection in single-select mode.
      selected = selected.slice(0, 1);
    }
  }
  return {
    activeIndex: -1,
    activeItem: undefined,
    initialItem: undefined,
    isFocused: false,
    selected: selected,
    showMenu: defaultOpen,
    text: text
  };
}
export function clearTypeahead(state, props) {
  return _objectSpread(_objectSpread({}, getInitialState(props)), {}, {
    isFocused: state.isFocused,
    selected: [],
    text: ''
  });
}
export function clickOrFocusInput(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isFocused: true,
    showMenu: true
  });
}
export function hideMenu(state, props) {
  var _getInitialState = getInitialState(props),
    activeIndex = _getInitialState.activeIndex,
    activeItem = _getInitialState.activeItem,
    initialItem = _getInitialState.initialItem;
  return _objectSpread(_objectSpread({}, state), {}, {
    activeIndex: activeIndex,
    activeItem: activeItem,
    initialItem: initialItem,
    showMenu: false
  });
}
export function toggleMenu(state, props) {
  return state.showMenu ? hideMenu(state, props) : _objectSpread(_objectSpread({}, state), {}, {
    showMenu: true
  });
}
function reducer(state, newState) {
  return _objectSpread(_objectSpread({}, state), newState);
}
export function useTypeaheadState(props) {
  var initialState = getInitialState(props);
  var _useReducer = useReducer(reducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var callbackQueue = useRef([]);
  useEffect(function () {
    // Trigger any post-state-change callbacks.
    if (callbackQueue.current.length) {
      callbackQueue.current.forEach(function (callback) {
        callback(state);
      });
    }
    // Reset the queue.
    callbackQueue.current = [];
  }, [state]);
  function setState(stateObjOrFn, cb) {
    var newState = isFunction(stateObjOrFn) ? stateObjOrFn(state, props) : stateObjOrFn;
    cb && callbackQueue.current.push(cb);
    dispatch(newState);
  }
  return [state, setState];
}